// extracted by mini-css-extract-plugin
export default {"root":"_3MlJU","scrollable":"_3jBtx","size-small":"_2Nkwn","sizeSmall":"_2Nkwn","size-medium":"_1nq9t","sizeMedium":"_1nq9t","tag-item":"_2W1m2","tagItem":"_2W1m2"};